import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import Select from 'react-select';

import { alpha } from '../../../styles';

const noop = () => {};

const Container = glamorous.div(({ theme, ...props }) => ({
  '& > .Select > .Select-control': {
    borderWidth: props.isBorderless ? 0 : 2,
    borderColor: theme.default.base,
    borderRadius: props.isBorderless ? 0 : 4,

    '&:hover': {
      boxShadow: 'none',
    },
  },

  [`
    & > .Select.is-focused > .Select-control,
    & > .Select.is-focused:not(.is-open) > .Select-control,
  `]: {
    borderColor: theme.primary.base,
    boxShadow: 'none',
  },

  '& > .Select > .Select-menu-outer': {
    borderWidth: props.isBorderless ? 0 : 2,
    borderColor: theme.primary.base,
    borderTopWidth: 1,

    borderBottomLeftRadius: props.isBorderless ? 0 : 4,
    borderBottomRightRadius: props.isBorderless ? 0 : 4,
  },

  '& > .Select .Select-option.is-focused': {
    backgroundColor: alpha(theme.primary.lightest, 0.11),
  },

  '& > .Select .Select-option.is-selected': {
    backgroundColor: alpha(theme.primary.lightest, 0.11),
  },
}));

class SelectField extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,

    defaultSelected: PropTypes.string,

    onChange: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })),

    isBorderless: PropTypes.bool,
  };

  static defaultProps = {
    onChange: noop,
    defaultSelected: '',
    options: [],

    isBorderless: false,
  };

  state = {
    selectedOption: this.props.defaultSelected,
  };

  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
    this.props.onChange(selectedOption);
  };

  render() {
    const { selectedOption } = this.state;
    const {
      name,
      onChange,
      options,
      isBorderless,
      ...rest
    } = this.props;

    return (
      <Container isBorderless={isBorderless}>
        <Select
          name={name}
          value={selectedOption}
          onChange={this.handleChange}
          options={options}
          {...rest}
        />
      </Container>
    );
  }
}

export default SelectField;



// WEBPACK FOOTER //
// ./src/components/ui/SelectField/SelectField.js